export const ORGANIZATION_IDS = {
  AUDI_OF_AMERICA: 4,
  VOLKSWAGEN_GROUP_AMERICA: 7,
  VOLKSWAGEN_OEM_LIBRARY: 38,
};
